import { MultipleColorsIconProps } from "typing";
import { theme } from "../themes";

export const ImageCardVirtualMyCards = ({
  width = 860,
  height = 542,
  color = theme.colors.neutral.white,
  secondColor = theme.colors.primary["350"],
  thirdColor = theme.colors.primary["200"],
  fourthColor = theme.colors.primary["85"],
  codeMyCard,
}: MultipleColorsIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 860 542"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <rect width="860" height="542" rx="8" fill="white" />
      <rect
        width="790"
        height="482"
        transform="translate(29 36)"
        fill={color}
      />
      <path
        d="M140.288 50.6254C142.623 50.6254 144.698 51.1478 146.252 52.4537C149.098 51.1481 152.205 50.5223 155.331 50.6254H163.633V54.2821C167.699 51.3084 172.617 49.7497 177.641 49.842C184.646 49.842 190.349 52.7146 193.984 57.4184V53.2371C192.927 51.5124 192.387 49.5173 192.428 47.4911C192.43 40.9626 197.619 36 204.624 36C211.628 36 216.816 40.701 216.816 47.4919C216.77 48.5539 216.596 49.6064 216.297 50.6261H221.226C223.396 50.5967 225.507 51.3362 227.19 52.7153C230.015 51.3216 233.123 50.6065 236.269 50.6261H253.39C267.399 50.6261 275.182 57.9388 275.182 71.5198V77.7883H279.073V90.5824H293.343V99.7256H313.318C327.326 99.7256 335.109 107.302 335.109 120.619V127.41H339V146.737H324.991C322.979 146.778 320.997 146.234 319.284 145.17C316.949 146.476 314.096 146.737 310.464 146.737H290.749C283.744 146.737 278.556 144.386 275.184 140.207C273.368 143.08 270.255 144.908 266.623 146.211C266.482 146.193 266.338 146.207 266.203 146.252C266.068 146.298 265.945 146.373 265.842 146.472C265.583 146.472 265.061 146.733 264.804 146.733H264.023C259.459 147.595 254.761 147.417 250.275 146.211C248.941 145.894 247.639 145.457 246.383 144.905C246.124 144.905 246.124 144.905 245.864 144.644C245.605 144.644 245.605 144.383 245.345 144.383C245.311 144.384 245.277 144.377 245.245 144.364C245.214 144.352 245.185 144.332 245.161 144.308C245.136 144.284 245.117 144.255 245.105 144.223C245.092 144.191 245.086 144.156 245.086 144.122C243.167 143.378 241.339 142.414 239.639 141.249C235.242 145.053 229.611 147.098 223.815 146.995C217.563 147.118 211.512 144.775 206.953 140.466V145.429L204.359 146.996C198.133 151.175 192.166 153 185.162 153C167.262 153 154.551 140.464 154.551 122.704C154.551 111.474 159.48 102.334 167.259 97.1096H89.4434C76.9916 97.1096 67.6523 89.2744 65.837 77.7825H56.2385V97.1117H33.9292V57.9388H29V37.5667H75.6946V53.4987C79.4957 51.0805 83.9063 49.8113 88.4026 49.842C94.888 49.842 100.335 52.1928 103.967 56.6322V50.6282H113.566C115.901 50.6282 117.976 51.1507 119.529 52.4566C122.376 51.1509 125.483 50.5252 128.609 50.6282L140.288 50.6254Z"
        fill={secondColor}
      />
      <path
        d="M204.364 53.2372C208.255 53.2372 210.849 50.8864 210.849 47.2332C210.849 43.8381 208.255 41.4873 204.364 41.4873C200.473 41.4873 197.878 43.8353 197.878 47.2304C198.138 51.148 200.732 53.2372 204.364 53.2372Z"
        fill={color}
      />
      <path
        d="M119.017 60.0279C118.498 57.6771 116.423 56.3712 114.088 56.3712H110.197V91.6295H120.832V72.3032C120.832 66.8188 124.464 64.468 129.393 64.468H131.728V56.1104H129.134C124.466 56.1104 120.832 57.6771 119.017 60.0279Z"
        fill={color}
      />
      <path
        d="M227.711 72.3032C227.711 66.8188 231.343 64.468 236.272 64.468H238.607V56.1104H236.012C231.343 56.1104 227.971 57.6771 225.895 60.0279C225.376 57.6771 223.301 56.3712 220.966 56.3712H217.075V91.6295H227.711V72.3032Z"
        fill={color}
      />
      <path
        d="M88.6653 55.3271C78.2887 55.3271 71.2844 62.9036 71.2844 73.8701C71.2844 84.317 78.5478 92.1521 89.7025 92.1521C94.8908 92.1521 99.301 91.1072 102.411 88.757V80.3994C98.782 82.4879 95.1506 83.2741 90.7369 83.2741C85.8077 83.2741 82.4355 80.6624 81.3983 76.2224H103.711V72.0425C103.711 62.1173 98.0039 55.3271 88.6653 55.3271ZM81.6609 68.9075C82.6989 65.5124 85.0332 63.4232 88.6653 63.4232C91.7784 63.4232 93.8535 65.5124 94.3725 68.9075H81.6609Z"
        fill={color}
      />
      <path
        d="M145.217 60.0279C144.698 57.6771 142.623 56.3712 140.288 56.3712H136.397V91.6295H147.033V72.3032C147.033 66.8188 150.665 64.468 155.593 64.468H157.928V56.1104H155.334C150.667 56.1104 147.293 57.6771 145.217 60.0279Z"
        fill={color}
      />
      <path
        d="M205.661 56.3713H199.435V91.6296H210.07V61.0723C210.33 58.1997 208.514 56.3713 205.661 56.3713Z"
        fill={color}
      />
      <path
        d="M34.7073 52.4537H37.5605C39.1167 52.4537 39.6357 52.9762 39.6357 54.5429V92.4136H50.7911V73.0866H66.8749V63.9455H50.7911V52.4537H70.2436V43.0518H34.7073V52.4537Z"
        fill={color}
      />
      <path
        d="M269.476 81.4436V70.9967C269.476 61.0723 264.547 55.8489 253.393 55.8489H243.017V64.2065H252.093C256.762 64.2065 259.097 65.7733 259.356 69.9525H256.243C245.611 69.9525 239.385 73.086 239.385 81.4436C239.385 87.9729 243.795 92.1514 250.799 92.1514C255.209 92.1514 257.803 90.323 260.138 87.7113C261.176 90.0622 262.991 91.368 265.326 91.368H273.627V83.5328H271.552C271.273 83.5587 270.992 83.5224 270.729 83.4265C270.465 83.3307 270.226 83.1776 270.028 82.9782C269.83 82.7788 269.678 82.538 269.582 82.2728C269.487 82.0076 269.451 81.7245 269.476 81.4436V81.4436ZM252.614 84.3169C252.154 84.3353 251.695 84.2619 251.263 84.101C250.831 83.9401 250.435 83.6949 250.098 83.3794C249.76 83.0639 249.488 82.6844 249.296 82.2627C249.105 81.8409 248.998 81.3852 248.982 80.9218C248.982 77.7876 251.058 76.7434 255.987 76.7434H259.1C259.1 81.1827 256.506 84.3169 252.614 84.3169Z"
        fill={color}
      />
      <path
        d="M178.422 92.152C183.611 92.152 188.021 91.107 191.393 88.7569V80.3993C187.761 82.4885 183.868 83.2719 179.46 83.2719C174.531 83.2719 171.159 80.6602 170.381 76.2201H192.431C192.763 74.7633 192.937 73.2746 192.95 71.78C192.949 61.8556 187.241 55.0654 177.644 55.0654C167.268 55.0654 160.263 62.6419 160.263 73.6084C160.263 84.3169 167.268 92.152 178.422 92.152ZM177.384 63.4231C180.497 63.4231 182.832 65.5123 183.092 68.9074H170.64C171.678 65.5123 173.752 63.4231 177.384 63.4231Z"
        fill={color}
      />
      <path
        d="M171.678 123.493C171.678 114.091 177.904 108.867 185.948 108.867C191.395 108.867 195.805 110.434 200.475 113.568V103.643C195.68 100.537 190.09 98.9033 184.389 98.9423C169.862 98.9423 160.263 109.128 160.263 123.754C160.263 138.379 170.381 148.304 185.167 148.304C190.911 148.381 196.536 146.646 201.251 143.342V133.156C196.062 136.551 191.133 138.118 185.945 138.118C177.903 137.857 171.678 132.634 171.678 123.493Z"
        fill={color}
      />
      <path
        d="M287.636 96.3306H276.741V127.932C276.741 137.334 282.704 140.991 290.749 140.991H295.938V132.372H292.046C289.193 132.372 287.377 130.805 287.377 127.149V113.829H297.755V105.472H287.376L287.635 96.3306H287.636Z"
        fill={color}
      />
      <path
        d="M331.736 133.155C330.18 133.155 329.661 132.369 329.661 131.066V120.881C329.661 110.695 324.731 105.471 313.577 105.471H302.681V113.829H312.536C317.205 113.829 319.54 115.396 319.799 119.575H316.427C305.792 119.575 299.828 122.709 299.828 131.066C299.828 137.595 303.978 141.774 310.983 141.774C315.393 141.774 318.246 139.685 320.581 137.334C320.881 138.409 321.529 139.352 322.422 140.014C323.315 140.677 324.402 141.02 325.51 140.991H333.812V133.155H331.736ZM312.799 133.678C310.464 133.678 308.907 132.372 308.907 130.544C308.907 127.409 310.983 126.104 316.171 126.104H319.281C319.281 130.544 316.69 133.678 312.799 133.678V133.678Z"
        fill={color}
      />
      <path
        d="M223.82 104.949C213.183 104.949 205.142 112.784 205.142 123.492C205.142 133.939 213.183 141.774 223.82 141.774C234.456 141.774 242.238 133.678 242.238 123.231C242.238 112.784 234.456 104.949 223.82 104.949ZM223.82 132.896C219.15 132.896 216.037 129.239 216.037 123.494C216.037 117.49 219.15 114.092 223.82 114.092C228.489 114.092 231.345 117.487 231.345 123.494C231.342 129.238 228.489 132.896 223.82 132.896Z"
        fill={color}
      />
      <path
        d="M245.87 115.918C245.87 120.881 248.464 123.495 254.69 126.104C259.619 128.194 261.435 129.239 261.435 130.805C261.435 132.634 260.397 132.895 258.063 132.895C253.739 133.002 249.457 132.014 245.611 130.022V138.38C248.464 140.208 253.912 141.514 259.1 141.514C266.882 141.514 272.33 137.074 272.33 130.545C272.33 124.015 267.402 121.664 262.473 119.577C258.063 117.488 256.247 117.226 256.247 115.66C256.247 114.093 257.284 113.57 260.138 113.57H272.33V105.211H259.36C251.318 105.211 245.87 109.128 245.87 115.918Z"
        fill={color}
      />

      <text
        fontSize="50"
        fontFamily="'Chivo',Arial,Helvetica,sans-serif"
        x="25"
        y="475"
        fill={thirdColor}
      >
        {codeMyCard}
      </text>
      <circle
        cx="698.294"
        cy="461.878"
        r="50.5968"
        stroke={fourthColor}
        strokeWidth="11"
      />
      <circle
        cx="758.706"
        cy="461.878"
        r="50.5968"
        stroke={fourthColor}
        strokeWidth="11"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M727.035 358.464L728.5 359.951L730.013 358.351C732.583 355.61 736.16 354.038 739.917 354.001C743.674 353.963 747.282 355.462 749.906 358.151L750.214 358.464C755.783 364.186 755.783 373.303 750.214 379.025L735.074 394.398C733.34 396.16 730.971 397.152 728.5 397.152C726.028 397.152 723.659 396.16 721.925 394.398L706.786 379.025C701.217 373.303 701.217 364.187 706.786 358.464C709.456 355.751 713.104 354.224 716.91 354.224C720.717 354.224 724.365 355.751 727.035 358.464Z"
        stroke={fourthColor}
        strokeWidth="11"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
